import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import SubscriptionForClient from "./SubscriptionForClient";
import SubscriptionForRepresentative from "./SubscriptionForRepresentative";

export default function SubscriptionModal({
  isOpen,
  onClose,
  selectedPriceId,
  mode = "client", // "client" ou "representative"
  selectedDuration = 6, // Durée par défaut,
}) {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-[40%] rounded-lg bg-white p-6 shadow-xl relative">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>

          {mode === "representative" ? (
            <SubscriptionForRepresentative selectedPriceId={selectedPriceId} />
          ) : (
            <SubscriptionForClient
              selectedDuration={selectedDuration}
              selectedBundleKey={selectedPriceId}
              onClose={onClose}
            />
          )}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
